export default __webpack_public_path__ + "static/studio-slider-24-4a4e8d04f7a83653522fcf90f32420a0.png";